import { Link } from "react-router-dom";
import { Check, ArrowRight, Heart, Scale, MapPin } from "lucide-react";
import PublicLayout from "../components/PublicLayout";
import SEO from "../components/SEO";
import { TEAM_PHOTO, PROCESS, ContactHours } from "../components/AboutTeam";

const H = { fontFamily: "Quicksand, sans-serif" };

export default function AboutPage() {
  return (
    <PublicLayout>
      <SEO
        title="Qui sommes-nous ? Des propriétaires au service des propriétaires"
        description="Bretagne Conciergerie Comparateur a été créé par des propriétaires bretons lassés de chercher une conciergerie. Une seule demande, un rappel téléphonique, la bonne conciergerie. Joignables 7j/7 de 10h à 20h."
        image={TEAM_PHOTO}
      />
      <section className="pt-8 pb-16" data-testid="about-page">
        <div className="container-tm grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <span className="pill">Notre histoire</span>
            <h1 className="h-display mt-5">Des propriétaires, au service des propriétaires</h1>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              Bretagne Conciergerie Comparateur est né d&apos;un ras-le-bol. Le nôtre. Celui de propriétaires bretons qui voulaient simplement confier leur location
              à quelqu&apos;un de fiable, et qui ont perdu des semaines à chercher.
            </p>
          </div>
          <div className="lg:col-span-6">
            <img src={TEAM_PHOTO} alt="L'équipe Bretagne Conciergerie Comparateur" className="w-full aspect-[3/2] object-cover blob" data-testid="about-team-photo" />
          </div>
        </div>
      </section>

      <section className="py-16 section-beige mx-3 md:mx-6">
        <div className="container-tm grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="h-section text-accent">Ce que nous avons vécu</h2>
            <ul className="mt-6 space-y-3 text-foreground/85">
              {["Des dizaines d'appels sans réponse ou des rappels une semaine plus tard.", "Des devis impossibles à comparer : chacun inclut (ou pas) le ménage, le linge, les photos…", "Des conciergeries qui finalement ne couvraient pas notre commune.", "Aucune idée de qui était vraiment sérieux."].map((t) => (
                <li key={t} className="flex gap-3"><span className="text-accent font-bold">•</span>{t}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="h-section text-accent">Ce que nous avons construit</h2>
            <ul className="mt-6 space-y-3 text-foreground/85">
              {["Une seule demande pour tout votre projet.", "Un vrai échange par téléphone pour comprendre vos besoins.", "Une conciergerie qui intervient réellement dans votre secteur.", "Un service 100% gratuit et sans engagement pour les propriétaires."].map((t) => (
                <li key={t} className="flex gap-3"><Check size={18} className="text-[hsl(var(--ocean))] shrink-0 mt-0.5" strokeWidth={3} />{t}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-tm">
          <h2 className="h-section">Comment nous travaillons</h2>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {PROCESS.map((p, i) => (
              <div key={p.t} className="surface-card p-8" data-testid={`about-process-${i}`}>
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 rounded-full bg-[hsl(var(--ocean))] text-white flex items-center justify-center"><p.icon size={18} /></span>
                  <span className="text-sm font-bold text-accent">Étape {i + 1}</span>
                </div>
                <h3 className="h-card mt-5">{p.t}</h3>
                <p className="mt-2 text-muted-foreground leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {[
              { icon: Heart, t: "Propriétaires avant tout", d: "Nous connaissons vos questions parce que ce sont les nôtres." },
              { icon: Scale, t: "Conseil honnête", d: "Nous vous orientons selon votre bien et vos besoins, pas selon qui paie le plus." },
              { icon: MapPin, t: "Ancrés localement", d: "Partout en Bretagne : nous connaissons le terrain." },
            ].map((v) => (
              <div key={v.t} className="flex gap-4">
                <v.icon size={22} className="text-accent shrink-0 mt-1" />
                <div><div className="font-bold" style={H}>{v.t}</div><p className="text-sm text-muted-foreground mt-1">{v.d}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-tm">
          <div className="blob-alt bg-accent text-white p-10 md:p-14 grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="h-section text-white">Parlons de votre bien</h2>
              <p className="mt-3 text-white/85">Écrivez-nous, nous vous rappelons pour comprendre votre projet.</p>
              <Link to="/devis" className="btn-sun mt-6" data-testid="about-cta-devis">Je demande un devis <ArrowRight size={16} /></Link>
            </div>
            <ContactHours dark />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
